/*eslint no-unused-vars: "off"*/

/**
 * @see: https://github.com/jaredpalmer/formik/tree/master/examples
 * @see: https://github.com/jaredpalmer/formik/issues/271, https://github.com/jaredpalmer/formik/issues/1633, @see: https://github.com/jaredpalmer/formik/issues/1218
 */
import React, { useState, useEffect, useContext } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import {
  TextField, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, CircularProgress, 
  Slider, Radio, RadioGroup, Checkbox, FormGroup, FormControlLabel, FormControl, FormLabel, 
  InputLabel, MenuItem, Select } from '@material-ui/core';

import { Formik, Form, Field, FieldArray, ErrorMessage } from 'formik';

// s4n 
import _ from 'lodash'
import ContextProductIndex from './../../../s4n/context/ProductIndex'
import HttpClient from './../../../utils/HttpClient'
import { injectIntl } from "gatsby-plugin-intl"
import Preloader from './../../s4n/Preloader'
import classNames from 'classnames';
import Yup from './../../s4n/Yup';
import FormHelper from './../../s4n/Form'
import { Collapse } from 'react-bootstrap' // https://react-bootstrap.github.io/utilities/transitions/#collapse
import { DisplayFormikState } from "./../formikHelper"



const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    // margin: theme.spacing(1),
    marginRight: 0,
  },
  formControlLabel: {
    
  },
  formControlLabelCheckbox: {
    padding: theme.spacing(0.5, 1),
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
  dialogActions: {
    padding: 0,
  },

  success: {
    backgrounColor: "#4caf50",
    borderColor: "#4caf50",
  }
}));

// @see: https://fontawesome.com/icons?d=gallery&q=faces&m=free
const marks = [
    {
        value: 1,
        label: <i className="far fa-sad-cry"></i>,
    },
    {
        value: 2,
        label: <i className="far fa-frown"></i>,
    },
    {
        value: 3,
        label: <i className="far fa-meh"></i>,
    },
    {
        value: 4,
        label: <i className="far fa-smile"></i>,
    },
    {
        value: 5,
        label: <i className="far fa-smile-beam"></i>,
    },
];



const FormStateless = (props) => {
  const { intl } = props;
  const t = intl.formatMessage;

  // const { classes } = props; // export default withStyles(styles)(injectIntl(FormStateless))
  const classes = useStyles();

  // @see: https://stackoverflow.com/questions/53344755/how-to-run-setsubmitting-outside-the-submit-handler
  // const formikRef = React.createRef();

  const contextProductIndex = useContext(ContextProductIndex);
// console.log(`contextProductIndex: `, contextProductIndex);

  // const [formStatus, setFormStatus] = useState({
  //   success: null,
  //   class: null,
  //   message: null,
  // });

  const [state, setState] = useState({
    loading: true,
    error: false,
    fetchedData: null,
  });

  const [stateCollapse, setStateCollapse] = useState({
      field_filter_narzedzia: true,
      field_filter_role_zawodowe: true,
  });

  let translation = {
      field_filter_narzedzia: {
          pl: `Narzędzia`,
          en: `Tools`,
      },
      field_filter_role_zawodowe: {
          pl: `Role zawodowe`,
          en: `Professional roles`,
      },
  }

  let formSchema = {
    sections: [
      // {
      //   // title: t({ id: "Filter Narzędzia" }),
      //   title: translation.field_filter_narzedzia[intl.locale],
      //   type: `FormGroupCheckbox`,
      //   elements: [
      //     {
      //       label: 'field_filter_narzedzia',
      //       elements: [
      //         `badania_kompetencji`,
      //         `e_learning_caly_program`,
      //         `e_learning_pojedyncze_lekcje`,
      //         `egzaminy`,
      //         `szkolenia_otwarte`,
      //       ]
      //     },
      //   ]
      // },

      // {
      //   title: t({ id: "Other" }),
      //   type: `RadioGroupRadio`,
      //   elements: [
      //     {
      //       label: 'other',
      //       elements: ['raz_w_miesiacu_lub_czesciej', 'kilka_razy_w_roku', 'raz_w_roku_lub_rzadziej', 'incydentalnie']
      //     },
      //   ]
      // },

      // {
      //   title: t({ id: "soft4net_webform_quality_check_form_section_3" }),
      //   type: `Slider`,
      //   elements: [
      //     'ogolny_poziom_wspolpracy_obslugi_', 
      //   ]
      // }
    ]
  }

  let initialValues = {
    // // section 
    // category: [],

    // field_filter_narzedzia: [],
    // field_filter_role_zawodowe: [],
    field_filter_narzedzia: contextProductIndex.filters.field_filter_narzedzia,
    field_filter_role_zawodowe: contextProductIndex.filters.field_filter_role_zawodowe,
  }

  const skipFieldValue = [
    `szkolenia_otwarte`,
  ]

  const validationSchema = Yup.object().shape({
    // name: Yup.string().required(),
    // email: Yup.string().email().required(),
    // message: Yup.string().required(),
  })

  const onValidate = (values) => {
      // console.log(`onValidate: `, values);
      onChange(values);
  }

  const onChange = (values) => {
    // console.log(`onChange: `, values);
    // actions.setSubmitting(true);
    // formikRef.current.setSubmitting(true);
    // actions.setStatus(undefined);
    contextProductIndex.updateFilters({
        ...values,
        
        offset: 0, // @todo: refactor

    });
    // actions.setSubmitting(false);
    // formikRef.current.setSubmitting(false);
  }

  const getInitialValuesFromContext = () => {
    const contextFiltersInitialValues = contextProductIndex.getFiltersInitial();
    const validResetObjectKeys = Object.keys(initialValues).filter(key => contextFiltersInitialValues.hasOwnProperty(key)); // === _.intersection(_.keys(initialValues), _.keys(contextFiltersInitialValues));

    const resetValues = {};
    validResetObjectKeys.forEach(key => {
      resetValues[key] = contextFiltersInitialValues[key];
    });

    return resetValues;
  }

  /**
   * @see: https://github.com/jaredpalmer/formik/issues/446
   * 
   * @param {*} values 
   * @param {*} actions 
   */
  const onReset = (values, actions) => {
      // console.log(`onReset: `, values);

      const resetValues = getInitialValuesFromContext();
    
      // console.log(resetValues);

      actions.resetForm(resetValues);
      values = resetValues;

      // actions.setSubmitting(true);
      onChange(values);
      // actions.setSubmitting(false);
  }

  const onSubmit = (values, actions) => {
      actions.setSubmitting(true);

      // actions.setStatus(undefined);
      contextProductIndex.updateFilters({
          ...values,
      });

      actions.setSubmitting(false);
  }

  const fetchData = async () => {

// !
// ! Add permission to Anonymousn user 'administer commerce_product fields'
// !

    const response = await HttpClient.jsonapi(intl.locale, `field_storage_config/field_storage_config`, `filter[entity_type][value]=commerce_product&filter[field_storage_config_type][value]=list_string`);
// console.log(`response.data: `, response.data);

    setState({
      loading: false,
      fetchedData: response.data,
      // fetchedData: processData(response),
    })
  }

  const processData = response => {
    // if (!response) {
    //   return false;
    // }

    // console.log(response.data)

    response.data.length && response.data.forEach((item, index) => {
      const field_name = item.attributes.field_name;
      const oAllowedValues = item.attributes.settings.allowed_values;

      skipFieldValue.forEach((skipValue, index) => {
        delete oAllowedValues[skipValue];
      });
    });

    return response.data;
  }

  const setTransation = () => {
    if (!state.fetchedData) {
      return false;
    }

    // Set translation
    state.fetchedData.data.forEach((item, index) => {
      const field_name = item.attributes.field_name;
      const allowed_values = item.attributes.settings.allowed_values;

      for (let allowedValueName in allowed_values) {
        translation[field_name][allowedValueName] = {
          [intl.locale]: allowed_values[allowedValueName],
        }
      }
    });

    return true;
  }

  const setFormSchema = () => {
    if (!state.fetchedData) {
      return false;
    }

    // Set formSchema
    state.fetchedData.data.forEach((item, index) => {
      const field_name = item.attributes.field_name;
      const oAllowedValues = item.attributes.settings.allowed_values;

      skipFieldValue.forEach((skipValue, index) => {
        delete oAllowedValues[skipValue];
      });

      let oFilter = {
        title: translation[field_name][intl.locale], // title: t({ id: "Filter Narzędzia" }),
        type: `FormGroupCheckbox`, // @todo: refactor - now fixed!!!
        elements: [
          {
            label: field_name,
            elements: Object.keys(oAllowedValues),
          },
        ]
      };

      formSchema.sections.push(oFilter);
    });

    return true;
  }

  /**
   * @see: https://reactjs.org/docs/hooks-effect.html
   * Same as componentDidMount() hook because we pass an empty array [] as second argument,
   * this argument watches for changes in passed arguments
   * In componentDidMount we have access to window object elsewhere not always!!!
   */
  useEffect(() => {
    // setState({ loading: true })

    (async () => {
      await fetchData();

      // if (!state.fetchedData) {
      //   return false;
      // }

    })();

    // setState({ loading: false })

  }, []);

  setTransation();
  setFormSchema();

  return (
    <React.Fragment>
      {state.loading ?
        <Preloader />
        : 
        <Formik
          // ref={formikRef}
          enableReinitialize={true} // Thanks to this Formik will update when context (`contextProductIndex`) changes!!!, @see: https://github.com/jaredpalmer/formik/issues/811
          initialValues={initialValues}
          validationSchema={validationSchema}
          // onSubmit={onSubmit}
          // onChange={onChange} // no such listener
          // onReset={onReset}
          onReset={props.onReset}
          validate={onValidate} // @see: https://github.com/jaredpalmer/formik/issues/271#issuecomment-407869424
        >
          {(props) => {
            const {
              values,
              errors,
              status,
              touched,
              dirty,
              isSubmitting,
              handleChange,
              handleBlur,
              handleSubmit,
              handleReset,

              setFieldValue,
              submitForm,

              // @see: https://github.com/jaredpalmer/formik/issues/1941
              validateField, 
              validateForm,

            } = props;

            // console.log(status)

            // const formStatusClass = classNames({
            //   // "mb-0": true,
            //   "alert": true,
            //   "d-none": null === formStatus.class,
            //   [`alert-${formStatus.class}`]: true,
            // });

            return (
              <React.Fragment>
                <Form 
                  onSubmit={handleSubmit} 
                  // className={initialValues.webform_id}
                  className="product-index-filter-sidebar"
                  
                  // onChange={handleChange}
                  // onChange={() => console.log("test")}
                  // onChange={this.handleFormChange}
                  // onChange={() => validateForm(values)} // FIX Formik v2???
                >

                  {/* <DisplayFormikState {...props.values} /> */}

                  {formSchema.sections.map((section, sectionIndex) => {
                    const sectionElementsDefaultLabel = section.elements[0].label;

                    return (
                      <React.Fragment key={`product-index-sidebar-section-${sectionIndex}`}>

                          <div className="collapse-wrapper">
                            <a
                                // href="#"
                                onClick={() => setStateCollapse((prevState, props) => ({
                                    ...prevState,
                                    [sectionElementsDefaultLabel]: !stateCollapse[sectionElementsDefaultLabel],
                                }))}
                                aria-controls={`collapse-filter-${sectionElementsDefaultLabel}`}
                                aria-expanded={stateCollapse[sectionElementsDefaultLabel]}
                                className={`btn btn-primary text-left w-100 collapse-indicator ${stateCollapse[sectionElementsDefaultLabel] ? `` : `collapsed`}`}
                            >
                                <span className="collapse-header">
                                  {section.title}
                                  {values[sectionElementsDefaultLabel] && values[sectionElementsDefaultLabel].length > 0 && 
                                    <span className="badge badge-light ml-2">{values[sectionElementsDefaultLabel].length}</span>}
                                </span>
                            </a>
                            <Collapse in={stateCollapse[sectionElementsDefaultLabel]}>
                              <div id={`collapse-filter-${sectionElementsDefaultLabel}`} className="card card-body">

                              {section.elements.map((element, elementIndex) => {
                                const elementLabel = typeof element === `object` ? element.label : element;

                                return (
                                  <React.Fragment key={`product-index-sidebar-section-element-${elementIndex}`}>
                                    {`FormGroupCheckbox` === section.type ? 

                                      // @see: https://codesandbox.io/s/o5pw1vx916
                                      <FieldArray 
                                        name={elementLabel}
                                      >
                                        {arrayHelpers => (

                                          <FormControl 
                                            component="fieldset" 
                                            className={classes.formControl}
                                          >
                                            {/* @see: https://material-ui.com/components/checkboxes/ */}
                                            {/* <FormLabel component="legend">Assign responsibility</FormLabel> */}
                                            <FormGroup 
                                              // aria-label={elementLabel} 
                                              // name={elementLabel} 
                                              // value={value} 
                                              // value={formStatus.formElements[elementLabel]} 
                                              // value={values.z_jakich_uslug_firmy_heuresis_mieli_panstwo_okazje_korzystac}
                                              // onChange={(e) => {
                                              //   handleChange();
                                              //   validateForm();
                                              // }} 
                                              // row // display horizontally
                                            >

                                                  {/* @see: https://codesandbox.io/s/o5pw1vx916 */}
                                                  {element.elements.map((item, itemIndex) => {
                                                    const input = item;

                                                    return <FormControlLabel
                                                      key={`product-index-sidebar-section-element-item-${itemIndex}`}
                                                      className={classes.formControlLabel}
                                                      control={
                                                        <Checkbox 
                                                          // name={elementLabel}
                                                          className={classes.formControlLabelCheckbox}
                                                          color="primary"
                                                          checked={values[elementLabel] && values[elementLabel].includes(input)} // this controls material ui if checked and reset, this reflects current state: if checked, what value has!!!
                                                          onChange={e => {
                                                            if (e.target.checked) {
                                                              arrayHelpers.push(e.target.value);
                                                            } else {
                                                              const idx = values[elementLabel].indexOf(e.target.value);
                                                              arrayHelpers.remove(idx);
                                                            }

                                                            // @see: https://github.com/jaredpalmer/formik/issues/1941, FIX Formik v2???
                                                            // validateForm();
                                                            // validateField(elementLabel);
                                                            // validateForm(values);

                                                          }}
                                                          value={input}
                                                        />
                                                      }
                                                      label={translation[elementLabel][item][intl.locale]}
                                                      // labelPlacement="end"
                                                    />
                                                  })}

                                              </FormGroup>
                                            </FormControl>

                                        )}

                                      </FieldArray>
                                      : 
                                      null
                                    }

                                    {`RadioGroupRadio` === section.type ? 

                                      // @see: https://material-ui.com/components/radio-buttons/
                                      <RadioGroup 
                                        aria-label={elementLabel} 
                                        name={elementLabel} 
                                        // value={value} 
                                        // value={values[elementLabel]} 
                                        // onChange={(event) => {
                                        //   handleChange(event)
                                        // }} 
                                        onChange={handleChange} 
                                        // row // display horizontally
                                      >

                                          {element.elements.map((item, itemIndex) => {
                                            const radio = item;

                                            return <FormControlLabel
                                              value={radio}
                                              control={
                                                <Radio 
                                                  color="primary"
                                                  checked={radio === values[elementLabel]} // this controls material ui if checked and reset, this reflects current state: if checked, what value has!!!
                                                />
                                              }
                                              // label={ item }
                                              label={translation[elementLabel][item][intl.locale]}
                                              // label={ t({ id: `soft4net_webform_quality_check_form_section_element_${elementLabel}_${radio}` }) }
                                              // labelPlacement="end"
                                            />
                                          })}

                                      </RadioGroup>
                                      : 
                                      null
                                    }

                                    {`Slider` === section.type ? 
                                      <React.Fragment>
                                        {/* 
                                          @see: https://material-ui.com/components/slider/ 
                                          @see: https://github.com/mui-org/material-ui/issues/13485
                                        */}
                                        <div className="container-fluid">
                                          <Slider
                                            value={values[elementLabel]} // this controls material ui if checked and reset, this reflects current state: if checked, what value has!!!
                                            // onChange={handleSliderChange}
                                            onChange={(event, newValue) => {
                                              // setFieldValue(elementLabel, event.currentTarget.files[0]);
                                              setFieldValue(elementLabel, newValue);
                                            }}
                                            defaultValue={1}
                                            // getAriaValueText={valuetext}
                                            // aria-labelledby="discrete-slider"
                                            aria-labelledby="discrete-slider-custom"
                                            // valueLabelDisplay="auto"
                                            valueLabelDisplay="on"
                                            step={1}
                                            marks={marks}
                                            min={1}
                                            max={5}
                                          />
                                        </div>
                                      </React.Fragment>
                                      : 
                                      null
                                    }

                                  </React.Fragment>
                                  
                                )
                              })}

                          </div>
                        </Collapse>
                      </div>

                      </React.Fragment>
                    )
                  })}

                  {/* Form status messages */}
                  {/* <div className="row form-status">
                    <div className="col">
                      <div dangerouslySetInnerHTML={{ __html: formStatus.message }} className={formStatusClass} role="alert"></div>
                    </div>
                  </div> */}

                  <div className="row">
                    <div className="col">
                      <DialogActions className={classes.dialogActions}>
                        
                        {/* <Button
                          type="button"
                          color="secondary"
                          variant="contained"
                          className="outline"
                          onClick={handleReset}
                          // disabled={!dirty || isSubmitting} // @see: enableReinitialize={true}
                          // disabled={!touched || isSubmitting} // @see: enableReinitialize={true}
                          disabled={_.isEqual(initialValues, getInitialValuesFromContext()) || isSubmitting} // @see: enableReinitialize={true}
                        >{ t({ id: "soft4net_form_action_reset" }) }</Button> */}

                        {/* {isSubmitting ? 
                          <CircularProgress /> : 
                          <Button 
                            type="submit" 
                            variant="contained" 
                            color="primary"
                            className={formStatus && formStatus.success ? 'green' : null}
                            disabled={isSubmitting}>{ t({ id: "soft4net_form_action_submit" }) }</Button>
                        } */}

                      </DialogActions>
                    </div>
                  </div>

                </Form>
                
                {/* <AutoSubmit values={values} submitForm={submitForm} /> */}

              </React.Fragment>
            );
          }}
        </Formik>
      }
      </React.Fragment>
    )
}

// export default withStyles(styles)(injectIntl(FormStateless))
export default injectIntl(FormStateless)